export default "__VITE_ASSET__DBhA0Q7z__"